import { DeviceType } from 'app/store/root-types';

export const equipmentGetter = (deviceType: DeviceType, networkData: MinesiderBackend.CustomerNetwork) =>
  networkData.equipmentList?.find((category) => category.category === deviceType);

export const isTwoBox = (networkData?: MinesiderBackend.CustomerNetwork) =>
  networkData?.installationType === 'EXTENDED' &&
  networkData?.accessPoints.some((ap) => ap.accessPointType === 'WIFI_EXTENDED');
